import { v4 } from 'uuid';
export function newClientIdentifier() {
    return v4();
}
